import { API_URL } from "./apiConfig";

// Admin email-notification switches (global / per-company / per-type).
// Backend: Hiring_Api EmailController (GetEmailSettings / SetEmailSetting).

// Returns rows: { id, company_code, notification_type, is_enabled, modified_date, modified_by }
export const getEmailSettings = async () => {
  try {
    const response = await fetch(`${API_URL}Email/GetEmailSettings`);
    if (!response.ok) throw new Error("Failed to fetch email settings");
    return await response.json();
  } catch (error) {
    console.error("Error fetching email settings:", error);
    return [];
  }
};

// dto: { companyCode (null=global), notificationType (null=all types), isEnabled, modifiedBy }
export const setEmailSetting = async (dto) => {
  try {
    const response = await fetch(`${API_URL}Email/SetEmailSetting`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
    if (response.ok) return await response.json();
    throw new Error("Failed to update email setting");
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
